import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { filterLocationIdsByACLs, isWeaveUser } from '@frontend/auth-helpers';

export const usePaymentRole = (locationIdOrIds: string | string[], strategy: 'any' | 'all' = 'any') => {
  /**
   * Permission.PAYMENTS_REFUNDS_AND_INVOICES_VIEW_ONLY should filter out any but the following roles:
   * - Billing Manager
   * - Super Admin
   * - Payments User
   */

  const locationIds = Array.isArray(locationIdOrIds) ? locationIdOrIds : [locationIdOrIds];

  const paymentsRoleLocationIds = filterLocationIdsByACLs({
    locationIds,
    acls: [Permission.PAYMENTS_REFUNDS_AND_INVOICES_VIEW_ONLY],
    strategy,
  });

  const isWeave = isWeaveUser();

  /**
   * If true, can see payment analytics.
   */
  const hasAnalyticsRole = paymentsRoleLocationIds.length > 0 || isWeave;

  /**
   * Locations filtered by payment role permissions.
   */
  const hasAnalyticsRoleLocationIds = isWeave ? locationIds : paymentsRoleLocationIds;

  return {
    hasAnalyticsRole,
    hasAnalyticsRoleLocationIds,
  };
};
